import { AuthService } from '../services';

const namespace = 'auth';

export const STORE_AUTH = `${namespace}/STORE_AUTH`;
export const STORE_USER_PROFILE = `${namespace}/STORE_USER_PROFILE`;

export function storeAuth(auth) {
  return {
    type: STORE_AUTH,
    auth
  }
}

export function getUserProfile() {
  return (dispatch) => {
    const profile = AuthService.getProfile();
    return dispatch(storeUserProfile(profile));
  }
}

export function storeUserProfile(profile) {
  return {
    type: STORE_USER_PROFILE,
    profile
  }
}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js